import { render, staticRenderFns } from "./CardScaffold.vue?vue&type=template&id=1f2c8146"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f2c8146')) {
      api.createRecord('1f2c8146', component.options)
    } else {
      api.reload('1f2c8146', component.options)
    }
    module.hot.accept("./CardScaffold.vue?vue&type=template&id=1f2c8146", function () {
      api.rerender('1f2c8146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/cards/CardScaffold.vue"
export default component.exports